import { useState } from 'react'
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

  
export default function FeedbackDialog(props) {
    const { onClose, open } = props;
    const [ratings, setRating] = useState({});    

    const handleSubmit = () => {
        ratings['comments'] = document.getElementById('comments').value;
        onClose(ratings);
    };

    const handleCancel = () => {
        onClose(null);
    };

    const setFeedbackRating = (category, val) => {
        ratings[category] = val;
        setRating(ratings);
    }

    return (
        <Dialog onClose={handleCancel} open={open}>
            <DialogTitle>How was your session?</DialogTitle>

            <DialogContent>
                <Typography component="legend">Speech recognition</Typography>
                <Rating
                    onChange={(event, newValue) => {
                        setFeedbackRating('speech-recognition', newValue);
                    }}
                />

                <Typography component="legend">Dialog (questions/advice)</Typography>
                <Rating
                    onChange={(event, newValue) => {
                        setFeedbackRating('dialog', newValue);
                    }}
                />

                <Typography component="legend">Usefulness</Typography>
                <Rating
                    onChange={(event, newValue) => {
                        setFeedbackRating('usefulness', newValue);
                    }}
                />

                <Typography component="legend">Other comments:</Typography>
                <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    name="comments"
                    multiline
                    id="comments"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleSubmit}>Submit</Button>
            </DialogActions>
        </Dialog>
    )
}
